@use 'styles/utils/variables' as *;

// antd sizes the image box for its illustrations (100px, and the svg to 100% of it); the Lucide
// glyph keeps its own size, so the box hugs it instead of leaving a tall gap above the text.
.image {
  height: auto !important;
  color: $text-color-secondary;

  & svg {
    height: auto !important;
  }
}

// The compact variant inside tables and lists: antd 4 gave it 32px above and below
// (`.ant-empty-normal`, which antd 6 only sets for its own simple illustration); without it the
// glyph sat flush against the table header.
.simple {
  margin-block: 3.2rem;
}

// antd's default for the description is the text colour at 45%, 2.4:1 on the light page and 3.9:1 on
// the dark one; the muted text token clears 4.5:1 in both themes.
.description {
  color: $text-color-secondary;
}
